import { CoverLimit } from "./CoverLimit";
import type { CoverLimitProps } from "./CoverLimit";

type CoverLimitsProps = {
  coverLimits: CoverLimitProps[];
};

export const CoverLimits = ({ coverLimits }: CoverLimitsProps) => {
  return coverLimits.map(coverLimit => (
    <CoverLimit key={coverLimit.title} {...coverLimit} />
  ));
};
